import { render } from "./itemAdd.vue?vue&type=template&id=98e9dfa4&scoped=true&ts=true"
import script from "./itemAdd.vue?vue&type=script&lang=ts&config=true"
export * from "./itemAdd.vue?vue&type=script&lang=ts&config=true"

import "./itemAdd.vue?vue&type=style&index=0&id=98e9dfa4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e9dfa4"]])

export default __exports__